import { z } from 'zod';
export const procurementImportCapability = 'procurement.import-reconciliation.v1';
export const procurementImportRunStatusSchema = z.enum([
    'prepared', 'applying', 'reconciled', 'failed', 'rolled-back',
]);
export const procurementImportCountsByEntitySchema = z.strictObject({
    'work-order': z.number().int().nonnegative().safe(),
    'purchase-order': z.number().int().nonnegative().safe(),
    subcontract: z.number().int().nonnegative().safe(),
    fulfillment: z.number().int().nonnegative().safe(),
    'fulfillment-event': z.number().int().nonnegative().safe(),
    receiving: z.number().int().nonnegative().safe(),
});
export const procurementImportDomainTotalsSchema = z.strictObject({
    quantityTenThousandths: z.number().int().nonnegative().safe(),
    plannedCostCents: z.number().int().nonnegative().safe(),
    actualCostCents: z.number().int().nonnegative().safe(),
    shortageQuantityTenThousandths: z.number().int().nonnegative().safe(),
});
export const procurementImportRunSummarySchema = z.strictObject({
    contractVersion: z.literal(procurementImportCapability),
    tenantId: z.string().uuid(),
    id: z.string().uuid(),
    mappingVersion: z.literal('procurement-normalized-v1'),
    sourceSystem: z.literal('crest-crm'),
    tenantExternalKey: z.string().trim().min(1).max(240),
    runKind: z.enum(['base', 'final-delta']),
    sourceEpoch: z.string().trim().min(1).max(240),
    parentSourceSha256: z.string().regex(/^[a-f0-9]{64}$/).nullable(),
    sourceSha256: z.string().regex(/^[a-f0-9]{64}$/),
    planSha256: z.string().regex(/^[a-f0-9]{64}$/),
    status: procurementImportRunStatusSchema,
    sourceRows: z.number().int().nonnegative(),
    plannedRows: z.number().int().nonnegative(),
    rejectedRows: z.number().int().nonnegative(),
    appliedRows: z.number().int().nonnegative().nullable(),
    skippedRows: z.number().int().nonnegative().nullable(),
    tombstonedRows: z.number().int().nonnegative().nullable(),
    targetSha256: z.string().regex(/^[a-f0-9]{64}$/).nullable(),
    countsByEntity: procurementImportCountsByEntitySchema.nullable(),
    domainTotals: procurementImportDomainTotalsSchema.nullable(),
    failureReasonCode: z.string().trim().min(3).max(160).nullable(),
    rollbackReason: z.string().trim().min(10).max(1_000).nullable(),
    startedByMembershipId: z.string().uuid(),
    startedAt: z.string().datetime({ offset: true }),
    completedAt: z.string().datetime({ offset: true }).nullable(),
    rolledBackAt: z.string().datetime({ offset: true }).nullable(),
});
//# sourceMappingURL=procurement-import.contract.js.map